import { PierDto } from '@storage/app/api'
import { EntityDialogFeatureStore } from '@storage/app/store/entity-dialog.feature-store'

export class PiersDialogFeatureStore extends EntityDialogFeatureStore<PierDto> {}
